import { USE_MAINNET } from './network';

export const CONTRACT_ADDRESSES = {
  MAINNET: '0xC5Ae1c063065d0AFd8740E62Eb6298eF5dA12fF1',
  TESTNET: '0xB4987b50AA3Ed2cB57c2f807f2dDE07E27857B4b'
};

export const USDT_ADDRESSES = {
  MAINNET: '0x55d398326f99059fF775485246999027B3197955',
  TESTNET: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC'
};

export const CONTRACT_ADDRESS = USE_MAINNET ? CONTRACT_ADDRESSES.MAINNET : CONTRACT_ADDRESSES.TESTNET;
export const USDT_ADDRESS = USE_MAINNET ? USDT_ADDRESSES.MAINNET : USDT_ADDRESSES.TESTNET;

export const APP_CONFIG = {
  telegramApiUrl: 'https://timetotime.us/api/telegram.php',
  telegramBotUsername: '@timetotime_notify_bot',
  websiteUrl: 'https://timetotime.us/'
};

export const CONTRACT_ABI = [
  "function register(uint256 referrerId) external",
  "function upgradePackage(uint256 packageId) external",
  "function retopupPackage(uint256 packageId) external",
  "function claimIncome() external",
  "function claimAllIncome() external",
  "function claimPoolIncome(uint256 packageId) external",
  "function claimRoyaltyIncome() external",
  "function addressToId(address) view returns (uint256)",
  "function users(uint256) view returns (address account, uint256 id, uint256 referrer, uint256 joinTime, bool isActive, bool isAdmin, uint256 totalDirectReferrals, uint256 claimableAmount, uint256 totalClaimed, uint256 totalIncome)",
  "function getUserDetails(uint256 userId) view returns (address account, uint256 id, uint256 referrer, bool isActive, bool isAdmin, uint256 totalDirectReferrals, uint256 claimableAmount, uint256 totalClaimed, uint256 totalIncome)",
  "function getUserPackageDetails(uint256 userId, uint256 packageId) view returns (bool isActive, uint256 activationTime, uint256 totalInvested, uint256 totalEarned, uint256 ceilingLimit, uint256 remainingLimit, bool unlimitedCeiling)",
  "function getUserPackages(uint256 userId) view returns (bool[10])",
  "function getMatrixDetails(uint256 userId, uint256 packageId) view returns (uint256 upline, uint256[] directDownlines, uint256 totalTeamSize)",
  "function getMatrixLevelUsers(uint256 userId, uint256 packageId, uint256 level) view returns (uint256[])",
  "function getMatrixLevelCounts(uint256 userId, uint256 packageId) view returns (uint256[10])",
  "function getUserIncomeBreakdown(uint256 userId) view returns (uint256 directReferralIncome, uint256 levelIncome, uint256 poolIncome, uint256 royaltyIncome, uint256 totalIncome, uint256 claimableAmount, uint256 totalClaimed)",
  "function getUserReferrals(uint256 userId) view returns (uint256[])",
  "function getUserTotalClaimableIncome(uint256 userId) view returns (uint256 regularIncome, uint256 poolIncome, uint256 royaltyIncome, uint256 totalClaimable)",
  "function getUserClaimablePoolIncome(uint256 userId, uint256 packageId) view returns (uint256)",
  "function getUserClaimableRoyaltyIncome(uint256 userId) view returns (uint256)",
  "function getUserActivities(uint256 userId) view returns (tuple(uint256 id, uint256 userId, uint256 activityType, uint256 amount, uint256 packageId, uint256 fromId, uint256 timestamp)[])",
  "function totalUsers() view returns (uint256)",
  "function packagePrices(uint256) view returns (uint256)",
  "function poolEligibility(uint256, uint256) view returns (bool)",
  "function royaltyEligibility(uint256) view returns (bool)",
  "function currentPoolRound(uint256) view returns (uint256)",
  "function currentRoyaltyRound() view returns (uint256)",
  "function poolEligibleUserCount(uint256) view returns (uint256)",
  "function royaltyEligibleUserCount() view returns (uint256)",
  "event UserRegistered(uint256 indexed userId, address indexed userAddress, uint256 indexed referrerId)",
  "event PackageActivated(uint256 indexed userId, uint256 indexed packageId)",
  "event PackageRetoppedUp(uint256 indexed userId, uint256 indexed packageId, uint256 amount, uint256 newLimit)",
  "event Claimed(uint256 indexed userId, uint256 amount)"
];

export const USDT_ABI = [
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function balanceOf(address account) external view returns (uint256)",
  "function decimals() external view returns (uint8)"
];

export const PACKAGE_PRICES = [10, 25, 50, 100, 200, 400, 800, 1000, 2000, 5000];

export const PACKAGE_INFO = {
  1: { name: 'GENESIS - $10', price: 10, icon: '🌱', color: '#00ff88' },
  2: { name: 'TEMPORAL - $25', price: 25, icon: '⏳', color: '#00d4ff' },
  3: { name: 'CHRONO - $50', price: 50, icon: '⚡', color: '#b429f9' },
  4: { name: 'EPOCH - $100', price: 100, icon: '🔮', color: '#ff6b00' },
  5: { name: 'FLUX - $200', price: 200, icon: '🌀', color: '#00ff88' },
  6: { name: 'VORTEX - $400', price: 400, icon: '💎', color: '#00d4ff' },
  7: { name: 'PARADOX - $800', price: 800, icon: '🔥', color: '#b429f9' },
  8: { name: 'CONTINUUM - $1000', price: 1000, icon: '⭐', color: '#ff6b00' },
  9: { name: 'INFINITY - $2000', price: 2000, icon: '🚀', color: '#00ff88' },
  10: { name: 'ETERNITY - $5000', price: 5000, icon: '👑', color: '#ffd700' }
};

export const ACTIVITY_TYPES = {
  0: { name: 'Registration', icon: '🚀', color: '#00ff88' },
  1: { name: 'Unit Upgrade', icon: '⬆️', color: '#00d4ff' },
  2: { name: 'Direct Income', icon: '💎', color: '#ffd700' },
  3: { name: 'Level Income', icon: '📊', color: '#b429f9' },
  4: { name: 'Pool Income', icon: '🌊', color: '#00d4ff' },
  5: { name: 'Claimed', icon: '✅', color: '#00ff88' },
  6: { name: 'Retopup', icon: '🔄', color: '#ff6b00' },
  7: { name: 'Royalty Income', icon: '👑', color: '#ffd700' }
};

export const DEFAULT_REFERRER = 100000;
